import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Accordion } from 'react-bootstrap';
import ReactDOMServer from 'react-dom/server';
import Sidebar from '../../../../Sidebar/Sidebar';
import AppLink from '../../../../../routing/helpers/AppLink';
import Translator from '../../../../components/helpers/Translator';

export default function EnvironmentalAspectsAssessmentSidebar({ activeRoute, assessmentTitle }) {
  const { moduleBridgeHex, plantHex } = useParams();
  const auth = useSelector((state) => state.auth);

  return (
    <Sidebar>
      <img
        src={auth.user?.client?.logoUrl}
        className="img-fluid"
        alt={auth.user?.client?.name}
        title={auth.user?.client?.name}
      />
      <Accordion>
        <ul>
          <li
            className={`${
              activeRoute === 'user_module_environmentalAspectsAssessment_assessment_current'
                ? 'active'
                : ''
            }`}
          >
            <AppLink
              path="user_module_environmentalAspectsAssessment_assessment_current"
              params={{
                moduleBridgeHex,
                plantHex,
              }}
              className="p-0"
            >
              <span className="sidebar-element">
                <span className="sb-title">{assessmentTitle}</span>
              </span>
            </AppLink>
          </li>
          <li
            className={`${
              activeRoute === 'user_module_environmentalAspectsAssessment_assessment_log_list'
                ? 'active'
                : ''
            }`}
          >
            <AppLink
              path="user_module_environmentalAspectsAssessment_assessment_log_list"
              params={{
                moduleBridgeHex,
                plantHex,
              }}
              className="p-0"
            >
              <span className="sidebar-element">
                <span className="sb-title">Histórico de evaluaciones</span>
              </span>
            </AppLink>
          </li>
          <li
            className={`${
              activeRoute === 'user_module_environmentalAspectsAssessment_inspection_list'
                ? 'active'
                : ''
            }`}
          >
            <AppLink
              path="user_module_environmentalAspectsAssessment_inspection_list"
              params={{
                moduleBridgeHex,
                plantHex,
              }}
              className="p-0"
            >
              <span className="sidebar-element">
                <span className="sb-title">Fichas de inspecciones</span>
              </span>
            </AppLink>
          </li>
        </ul>
      </Accordion>
    </Sidebar>
  );
}
